(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-hs-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observeAll() {
    document.querySelectorAll('[data-hs-animate]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  document.addEventListener('shopify:section:load', observeAll);
})();
